// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import moment from 'moment';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import DateRange from 'common/domain/DateRange';
import Estimation from 'common/modules/proposition/domain/estimation';
import DemographyCard from 'common/modules/printing/components/DemographyCard';

import SalesPrintingSummary from './SalesPrintingSummary';
import SalesPrintingListing from './SalesPrintingListing';
import Sampling from '../estimation/Sampling';
import PrintingHeader from '../../../printing/components/PrintingHeader';

const Wrapper = styled.div`
  width: 100%;
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  font-size: 12px;

  @page {
    size: letter portrait;
    margin: 2.00cm 0 2.00cm 0;
  }
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 16px;
  margin-top: ${({ theme }) => theme.metrics.tinyMargin}px;
  text-align: center;
`;

const Content = styled.div`
  margin-top: 0px;
`;

type Props = {
  dateRange: ?DateRange,
  estimation: Estimation,
  radio: Radio,
  theme: any,
  t: any,
}

function SalesPrinting({ dateRange, estimation, radio, theme, t }: Props) {
  return (
    <Wrapper>
      <PrintingHeader radio={radio} centralMarket={estimation.centralMarket} />
      {dateRange &&
      <Text>{t('campaignDateDisplay', dateRange)}</Text>
      }
      <Text>{t('campaignProposedOn', { date: moment() })}</Text>
      <Text>{t('propositionInformationMessage', {
        from: estimation.metricsDateRange.from,
        to: estimation.metricsDateRange.to,
      })}</Text>
      <Content>
        <Text>{t('totalSummary')}</Text>
        <SalesPrintingSummary summary={estimation.getTotalSummary()} />
        <Text>{t('opportunities')}</Text>
        <SalesPrintingListing opportunities={estimation.opportunities} />
        <DemographyCard genderDemography={estimation.genderDemography} ageGroup={estimation.ageGroup} />
        {estimation.sampling &&
        <Sampling hideTotal sampling={estimation.sampling} />
        }
      </Content>
    </Wrapper>
  );
}

export default withTheme(translate('commonSales')(SalesPrinting));



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/printing/SalesPrinting.js